module.exports = __webpack_public_path__ + "static/media/img-meher-razdan.b5d997a2.png";